import { ref } from 'vue'
import { defineStore } from 'pinia'
import * as agentsApi from '@/apis/agents.api'

export const useAgentsStore = defineStore('agents', () => {
  const groupsCache = ref({})

  const clear = () => {
    groupsCache.value = {}
  }

  const fetchGroups = async(agentId, forceRefresh = false) => {
    if (!agentId) return []

    const cacheEntry = groupsCache.value[agentId] || { data: [], lastModified: null }

    if (!forceRefresh && cacheEntry.lastModified) {
      const headers = { 'If-Modified-Since': cacheEntry.lastModified }
      try {
        const response = await agentsApi.fetchAgentGroupsAsync(agentId, { headers })
        if (response.status === 304) {
          return cacheEntry.data
        }
      } catch (error) {
        if (error.response && error.response.status !== 304) {
          console.error('Error fetching groups:', error)
          throw error
        }
      }
    }

    const response = await agentsApi.fetchAgentGroupsAsync(agentId)
    const lastModified = response.headers['last-modified']
    groupsCache.value[agentId] = { data: response.data, lastModified }
    return response.data
  }

  return {
    groupsCache,
    fetchGroups,
    clear
  }
}, {persist: [
  {
    pick: ['groupsCache'],
    storage: localStorage
  }
]})
